var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"initiate-action-table-cell"},[_c('div',{staticClass:"initiate-action-section",on:{"click":_vm.initiateAction}},[_c('span',{staticClass:"material-icons"},[_vm._v(" build ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }